<app-loader *ngIf="isDisabled"></app-loader>
<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        <div class="row">
            <div class="col">
                MUSTER ATTENDANCE
            </div>
            <div class="col-auto" style="align-content:center;font-weight:700">Sites : </div>
            <div class="col-auto p-0">
                <ng-select [items]="this.common.SiteStatus" name="SiteStatus" bindLabel="Name" bindValue="Value"
                    placeholder="Status" [(ngModel)]="SiteStatus" [virtualScroll]="true" [clearable]="false"
                    style="width: 200px;" (change)="ESS_FillComboOAS();clear()">
                </ng-select>
            </div>
        </div>
    </div>
    <div class="card-body p-1">
        <div class="p-2">
            <form class="g-3" name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
                <div class="row gx-3 gy-2 mb-2">
                    <div class="col-md-3">
                        <ng-select [items]="Zones" name="Zones" bindLabel="ZoneName" bindValue="ZoneMasterID"
                            placeholder="All Zone" [(ngModel)]="filter.ZoneMasterID" [virtualScroll]="true"
                            (change)="DropdownChange('Zone');clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-3">
                        <ng-select [items]="Sectors" name="Sectors" bindLabel="SectorName" bindValue="SectorId"
                            placeholder="All Sector" [(ngModel)]="filter.SectorId" [virtualScroll]="true"
                            (change)="DropdownChange('Sector');clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-3">
                        <ng-select [items]="Groups" name="Groups" bindLabel="GroupName" bindValue="GroupId"
                            placeholder="All Group" [(ngModel)]="filter.GroupId" [virtualScroll]="true"
                            (change)="DropdownChange('Group');clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-3">
                        <ng-select [items]="Branchs" name="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                            placeholder="All Branch" [(ngModel)]="filter.BranchMasterID" [virtualScroll]="true"
                            (change)="DropdownChange('Branch');clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-3">
                        <ng-select [items]="Clients" name="Clients" bindLabel="ClientGroupName"
                            bindValue="ClientGroupMasterID" placeholder="All Client"
                            [(ngModel)]="filter.ClientGroupMasterID" [virtualScroll]="true"
                            (change)="DropdownChange('Client');clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-6">
                        <ng-select [items]="Sites" name="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                            placeholder="All Site" [(ngModel)]="filter.SiteMasterID" [virtualScroll]="true" required
                            (change)="clear()">
                            <ng-template ng-option-tmp let-item="item">
                                <span>{{item.SiteName}}</span>
                            </ng-template>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select site.
                        </div>
                    </div>
                    <div class="col-md-3">
                        <ngb-datepicker #monthyear name="monthyear" [(ngModel)]="filter.MonthYear" class="month-year"
                            (navigate)="filter.MonthYear= $event.next;onNavigate($event);clear()"
                            required></ngb-datepicker>

                        <div class="invalid-feedback">
                            Please month year.
                        </div>
                    </div>
                    <div class="col"></div>
                    <div class="col-auto">
                        <button class="btn btn-sm btn-primary" type="submit" [disabled]="isDisabled"><i
                                class="bi bi-funnel me-2" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Apply':'Applying...'}}
                        </button>
                        <button class="btn btn-sm btn-primary mx-2" type="button" [disabled]="isDisabled"
                            (click)="ExcelDump()"><i class="bi bi-file-earmark-spreadsheet me-2"
                                *ngIf="!isDisabled && this.POCInfo.IsExcel"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Excel':'Applying...'}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="card border-radius-0 mt-1 p-0">
    <form name="MusterAttendanceForm" (ngSubmit)="Validate(MusterAttendanceForm)" #MusterAttendanceForm="ngForm"
        novalidate>
        <div class="card-body p-1">
            <app-muster-attendance-summary #musterSummary [dateKeys]="this.dateKeys" [leftColumns]="4"
                [centerColumns]="6" [rightColumns]="13" [siteID]="this.filter.SiteMasterID"
                [FromDate]="this.POCInfo.SalaryStartDate" [DesignationSummaryData]="this.DesignationSummaryData"
                [ToDate]="this.POCInfo.SalaryEndDate" (empwiseClick)="Empwisesummary($event)"
                (datewiseClick)="Datewisesummary($event)" (daychange)="DayChange($event)"
                (deleteEmpClick)="deleteEmp($event)">
            </app-muster-attendance-summary>
        </div>
        <div class="card-footer">
            <div class="row mb-2" *ngIf="this.SummaryData.length > 0">
                <div style="width:auto">
                    <div class="control-group">
                        <span class="control-label">
                            <i class="bi bi-file-earmark-arrow-up-fill"></i> Acknowledgment:
                        </span>
                        <div class="file-upload-wrapper" *ngIf="this.POCInfo.IPOCAttachment == null">
                            <input id="file-upload" type="file" style="display: none"
                                (change)="uploadaknowledgment($event)" accept=".jpeg,.jpg,.png,.pdf">
                            <label type="button" role="button" class="upload-btn" id="browseBtn" for="file-upload" *ngIf="!this.POCInfo.IsLocked">
                                <i class="bi bi-folder2-open"></i>
                                Browse
                            </label>
                        </div>
                        <div id="fileStatus" class="file-status" *ngIf="this.POCInfo.IPOCAttachment != null">
                            <i class="fas fa-check-circle"></i>
                            <!-- <span id="fileName">{{this.POCInfo.IPOCAttachment}}</span> -->
                            <button  type="button" class="btn btn-sm btn-danger me-1" id="removeFile" (click)="removeFile()" *ngIf="!this.POCInfo.IsLocked">
                                <i class="bi bi-x-circle-fill"></i>
                            </button>
                            <a [href]="this.POCInfo.IPOCAttachmentURL" target="_blank" role="button" class="btn btn-sm btn-primary"
                                *ngIf="this.POCInfo.IPOCAttachment != null &&this.POCInfo.IPOCAttachment != ''">
                                <i class="bi bi-paperclip"></i>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row gx-1">
                <div class="col-5 pt-3">
                    <div class="row gap-3">
                        <div class="col-12">
                            <div class="container" *ngIf="this.SummaryData.length > 0">
                                <div class="position-relative text-center">
                                    <!-- Progress Line -->
                                    <div class="position-absolute top-50 start-0 w-100 translate-middle-y"
                                        *ngIf="this.POCInfo.IsInternalPOCApplicable && this.POCInfo.IsClientPOCApplicable"
                                        [ngClass]="{'w-100':this.POCInfo.IsClientPOCApplicable,'w-50':!this.POCInfo.IsClientPOCApplicable}"
                                        style="height: 4px; background-color: #ddd;"></div>

                                    <!-- Left Button -->
                                    <div class="position-absolute top-50 start-0 translate-middle-y gap-1 d-grid"
                                        *ngIf="this.POCInfo.IsInternalPOCApplicable && !(this.POCInfo.IsAttendanceLocked && this.POCInfo.InternalPOCStatus == null)">
                                        <button type="button" class="btn btn-sm btn-primary px-3 py-1" style="opacity:1"
                                            (click)="openSPOC('I',dSPOC)"
                                            [ngStyle]="{'background':(this.POCInfo.InternalPOCStatus != null && this.POCInfo.InternalPOCStatus != '' && this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) != 'pending' && this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) != 'rejected')?'gray':''}"
                                            [disabled]="!(this.POCInfo.InternalPOCStatus == null || this.POCInfo.InternalPOCStatus == '' || this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'pending' || this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'rejected' )">Internal
                                            SPOC</button>
                                    </div>

                                    <!-- Right Button -->
                                    <div class="position-absolute top-50 end-0 translate-middle-y gap-1 d-grid"
                                        *ngIf="this.POCInfo.IsClientPOCApplicable  && !(this.POCInfo.IsAttendanceLocked && this.POCInfo.ClientPOCStatus == null)">
                                        <button type="button" class="btn btn-sm btn-primary px-3 py-1" style="opacity:1"
                                            [ngStyle]="{'background':(this.POCInfo.IsInternalPOCApplicable && !(this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'approved')) || !(this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == 'pending' || this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == 'rejected' || this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == '' ||this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == null) ?'gray':''}"
                                            (click)="openSPOC('C',dSPOC)"
                                            [disabled]="this.POCInfo.IsInternalPOCApplicable && (this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'approved') && !(this.POCInfo.ClientPOCStatus == null || this.POCInfo.ClientPOCStatus == '' || this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == 'rejected'|| this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == 'pending')">CLIENT
                                            SPOC</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="container" *ngIf="this.SummaryData.length > 0">
                                <div class="row">
                                    <div class="col-auto"
                                        *ngIf="this.POCInfo.IsInternalPOCApplicable && !(this.POCInfo.IsAttendanceLocked && this.POCInfo.InternalPOCStatus == null)">
                                        <span class="badge"
                                            [ngClass]="{'success':this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'approved', 'danger':this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'rejected', 'warning':this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'pending', 'view':(this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == '' || this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == null) }">
                                            {{(this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == '' ||
                                            this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == null)?'Open for
                                            approval':this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) ==
                                            'pending'?'Pending for Approval':this.POCInfo.InternalPOCStatus}}
                                        </span>
                                    </div>
                                    <div class="col"></div>
                                    <div class="col-auto"
                                        *ngIf="this.POCInfo.IsClientPOCApplicable  && !(this.POCInfo.IsAttendanceLocked && this.POCInfo.ClientPOCStatus == null)">
                                        <span class="badge"
                                            *ngIf="(this.common.ToLowerCase(this.POCInfo.InternalPOCStatus) == 'approved' || !this.POCInfo.IsInternalPOCApplicable)"
                                            [ngClass]="{'success':this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == 'approved', 'danger':this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == 'rejected', 'warning':this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == 'pending', 'view':(this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == '' || this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == null) }">
                                            {{(this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == '' ||
                                            this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) == null)?'Open for
                                            approval':this.common.ToLowerCase(this.POCInfo.ClientPOCStatus) ==
                                            'pending'?'Pending for Approval':this.POCInfo.ClientPOCStatus}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col"></div>
                <div class="col-auto" *ngIf="this.SummaryData.length > 0">
                    <div ngbDropdown class="arrow-none text-center" container="body">
                        <!-- Main Dropdown Toggle Button -->
                        <button type="button" class="btn btn-sm btn-outline-success" [disabled]="isDisabled"
                            ngbDropdownToggle>
                            <i class="bi bi-download me-2" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled ? 'Report' : 'Loading...'}}
                        </button>

                        <!-- Dropdown Menu -->
                        <div ngbDropdownMenu>
                            <!-- Excel section header -->
                            <h6 class="dropdown-header">Export as Excel</h6>

                            <!-- Excel options -->
                            <a class="dropdown-item" href="javascript:void(0)"
                                (click)="ESS_SiteWiseAttendancePOCOASGenExcelPdf(true,false,false)">
                                <i class="bi bi-file-earmark-spreadsheet me-2"></i>
                                Monthly Summary
                            </a>

                            <a class="dropdown-item" href="javascript:void(0)"
                                (click)="ESS_SiteWiseAttendancePOCOASGenExcelPdf(false,true,false)">
                                <i class="bi bi-file-earmark-spreadsheet me-2"></i>
                                Billing Summary
                            </a>

                            <!-- Divider between Excel and PDF -->
                            <div class="dropdown-divider"></div>

                            <!-- PDF option -->
                            <a class="dropdown-item" href="javascript:void(0)"
                                (click)="ESS_SiteWiseAttendancePOCOASGenExcelPdf(false,false,true)">
                                <i class="bi bi-filetype-pdf me-2"></i>
                                PDF Report
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-auto"
                    *ngIf="this.SummaryData.length > 0 && !this.POCInfo.IsInternalPOCApplicable && !this.POCInfo.IsClientPOCApplicable && !this.POCInfo.IsLocked">
                    <button type="button" class="btn btn-sm btn-success" [disabled]="isDisabled"
                        (click)="ResetPOC('Lock')"><i class="bi bi-lock-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Lock Site':'Loading...'}}</button>
                </div>
                <div class="col-auto" *ngIf="this.POCInfo.IsLocked && this.common.PageRight.IsEdit">
                    <button type="button" class="btn btn-sm btn-danger"
                        [disabled]="isDisabled || !this.CompanyPermiter.IsAttendanceResetAllowed"
                        (click)="ResetPOC('Reset')"><i class="bi bi-arrow-clockwise" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Reset':'Loading...'}}</button>
                </div>
                <div class="col-auto"
                    *ngIf="!this.POCInfo.IsLocked && this.SummaryData.length > 0 && this.common.PageRight.IsEdit">
                    <input id="file-upload" type="file" style="display: none" (change)="upload($event)"
                        accept=".xls,.xlsx">

                    <label for="file-upload" class="btn btn-sm btn-primary">
                        <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                    </label>
                </div>
                <div class="col-auto"
                    *ngIf="this.SummaryData.length > 0 && !this.POCInfo.IsLocked && this.common.PageRight.IsEdit">
                    <button type="submit" class="btn btn-sm btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </form>
</div>
<hr>
<div class="card border-radius-0 mt-1 p-0" *ngIf="this.Tracking.length > 0">
    <div class="card-header">
        <div class="row">
            <div class="col">
                ATTENDANCE HISTORY
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="isDisabled"
                    (click)="openTrackingHistory()"><i class="bi bi-clock-history" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'History':'Loading...'}}</button>
            </div>
        </div>
    </div>
    <div class=" card-body p-1">
        <div class="row">
            <table datatable [dtOptions]="dtOptionsTracking" [dtTrigger]="dtTrigger" id="tracking"
                class="customeDatatable table table-bordered" name="tracking" style="font-size: xx-small !important">
            </table>
        </div>
    </div>
</div>
<hr>
<div class="card border-radius-0 mt-1 p-0"
    *ngIf="this.DesignationSummaryData.length > 0 || this.DesignationSummaryBillingData.length > 0 ">
    <div class="card-header">
        <div class="row">
            <div class="col">
                DESIGNATION SUMMARY
            </div>
            <div class="col-auto"
                *ngIf="filter.ListType == 2 && this.DesignationSummaryBillingData.length > 0 && !this.POCInfo.IsLocked">
                <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="isDisabled"
                    (click)="DesignationSummaryEdit()"><i class="bi bi-pencil-square" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Edit':'Loading...'}}</button>
            </div>
        </div>
    </div>
    <div class="card-body p-1">
        <div class="row">
            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button" class="btn btn-outline-primary" style="width:100%"
                    [class.active]="filter.ListType === 1" [value]="1" (click)="setSelectType(1)">
                    <i class="bi bi-person-lines-fill"></i> Designation Summary
                </button>
                <button type="button" class="btn btn-outline-primary" [class.active]="filter.ListType === 2"
                    style="width:100%" [value]="2" (click)="setSelectType(2)">
                    <i class="bi bi-receipt"></i> Billing Summary
                </button>
            </div>
        </div>
        <div class="row">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="designationWiseSummarydata"
                class="customeDatatable table table-bordered" name="designationWiseSummarydata"
                style="font-size: xx-small !important">
            </table>
        </div>
    </div>
</div>

<ng-template #dSPOC let-offcanvas>
    <div class="offcanvas-header bgThemeColor">
        <div class="offcanvas-title d-flex">
            Send TO SPOC - {{this.Type == 'I'?'Internal':this.Type == 'C'?'Client':''}}
        </div>
    </div>
    <div class="offcanvas-body">
        <form name="POCForm" (ngSubmit)="ValidatePOC(POCForm)" #POCForm="ngForm">
            <div class="card">
                <div class="card-body">
                    <div class="row g-4">
                        <div class="col-md-12">
                            <table datatable [dtOptions]="dtOptionsPOC" [dtTrigger]="dtTrigger" id="pocdata"
                                class="customeDatatable table table-bordered" name="pocdata"
                                style="font-size: xx-small !important">
                            </table>
                        </div>
                        <div class="col-md-12">
                            <label class="colorThemeColor">FORMATS</label>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-check custom-checkbox">
                                    <input class="form-check-input" type="checkbox" id="MonthlySummary"
                                        name="MonthlySummary" [(ngModel)]="POCFilter.IsMonthlySummary">
                                    <small class="label" for="MonthlySummary">Monthly
                                        Summary</small>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-check">
                                    <input class="form-check-input custom-checkbox" type="checkbox" id="BillingSummary"
                                        name="BillingSummary" [(ngModel)]="POCFilter.IsBillingSummary">
                                    <small class="label" for="BillingSummary">Billing
                                        Summary</small>
                                </div>
                            </div>

                            <span *ngIf="!POCFilter.IsMonthlySummary && !POCFilter.IsBillingSummary"
                                style="font-size: small; color: red;">Please select atleast one checkbox</span>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-12">
                                <label for="MailIds" class="colorThemeColor">Additional
                                    Email</label>
                                <hr>
                                <small class="fst-italic text-muted"> The selected SPOC(s) will receive
                                    attendance
                                    summary
                                    for the month of {{this.dateFormate.fullmonth[this.filter.MonthYear.month -
                                    1]}}
                                    {{this.filter.MonthYear.year}}</small>
                                <input type="text" class="form-control" id="MailIds" name="MailIds"
                                    [(ngModel)]="POCFilter.MailIds" #MailIds="ngModel"
                                    [ngClass]="{'is-invalid': MailIds.invalid && MailIds.touched}"
                                    pattern="^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,},\s*)*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$">

                                <div *ngIf="MailIds.invalid && MailIds.touched" class="invalid-feedback">
                                    Please enter valid email(s) separated by commas.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer p-2">
                    <div class="row">
                        <div class="col"></div>
                        <div class="col-auto">
                            <button type="button" class="btn  btn-sm btn-outline-primary me-1"
                                (click)="offcanvas.dismiss('Cross click')" [disabled]="isDisabled" ngbTooltip="Cancel"
                                container="body" placement="top">
                                Cancel
                                <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                    aria-hidden="true"></span>
                            </button>

                            <button type="submit" class="btn btn-sm btn-primary text-white" [disabled]="isDisabled"><i
                                    class="bi bi-send-check" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Send':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>